declare global {
    interface Window {
        EASAS: any;
        contextRoot: string;
        jsBasePath: string;
        isEditMode: boolean;
        scada: ScadaLegacyConf;
    }
}

interface ScadaLegacyConf {
    selectedLabels: Array<any>;
    lastClick: number
}

window.scada = {
    lastClick: new Date().getTime() - 1000,
    selectedLabels: [],
}

export {}